module.exports = __webpack_public_path__ + "img/logo.abff5a88.svg";